import * as React from "react";
import { useFeatureToggles, useIntl } from "@grandvisionhq/state";
import { DeliveryIndicatorFullDateContainer } from "../../../../containers/modules/DeliveryIndicator/containers/DeliveryIndicatorFullDate.js";
import { DeliveryIndicatorBasicContainer } from "../../../../containers/modules/DeliveryIndicator/containers/DeliveryIndicatorBasic.js";
const DeliveryIndicator = ({
  items,
  deliveryResolver,
  availability,
  fallbackLabel,
  hasRxLens,
  ...rest
}) => {
  const { isDeliveryFullDateEnabled } = useFeatureToggles();
  const { getLabel } = useIntl();
  const fallbackLabelValue = fallbackLabel ?? getLabel("products.deliveryIndicator.fallbackMessage");
  if (isDeliveryFullDateEnabled && items && items.length > 0) {
    return /* @__PURE__ */ React.createElement(
      DeliveryIndicatorFullDateContainer,
      {
        items,
        fallbackLabel: fallbackLabelValue,
        hasRxLens,
        ...rest
      }
    );
  }
  return (
    // Basic delivery indicator that renders delivery estimate based on stock levels
    /* @__PURE__ */ React.createElement(
      DeliveryIndicatorBasicContainer,
      {
        deliveryResolver,
        availability,
        fallbackLabel: fallbackLabelValue,
        ...rest
      }
    )
  );
};
export {
  DeliveryIndicator
};
//# sourceMappingURL=DeliveryIndicator.js.map
